<template>
  <div class="step-controllers">
    <ElButton
      v-if="previousStep"
      :icon="arrowIconBasedOnDirection"
      type="text"
      @click="goPreviousStep"
    >
      {{ $t('APPS.DRAFT.PREVIOUS_STEP') }}
    </ElButton>

    <ElButton
      v-if="nextStep"
      class="step-controllers__next el-button--reverse-icon"
      type="primary"
      :icon="nextArrowIconBasedOnDirection"
      @click="goNextStep"
    >
      {{ $t('APPS.DRAFT.NEXT_STEP') }}
    </ElButton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DRAFT_APP } from '@/store/types';
import lang from '@/mixins/lang';
import getDraftAppNextStep from './getDraftAppNextStep';
import getDraftAppPrevStep from './getDraftAppPrevStep';
import { APP_CREATION_STEPS } from './constants';

export default {
  name: 'StepControllers',
  mixins: [lang],

  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
    nextStep() {
      const { haveIap, currentState } = this.draftApp;
      const nextStep = getDraftAppNextStep(currentState);
      const goingToIAP = nextStep === APP_CREATION_STEPS.IN_APP_PURCHASE;

      if (goingToIAP && !haveIap) {
        return getDraftAppNextStep(nextStep);
      }

      return nextStep;
    },
    previousStep() {
      const { haveIap, currentState } = this.draftApp;
      const prevStep = getDraftAppPrevStep(currentState);
      const goingToIAP = prevStep === APP_CREATION_STEPS.IN_APP_PURCHASE;

      if (goingToIAP && !haveIap) {
        return getDraftAppPrevStep(prevStep);
      }

      return prevStep;
    },
    arrowIconBasedOnDirection() {
      return this.lang === 'fa' ? 'el-icon-arrow-right' : 'el-icon-arrow-left';
    },
    nextArrowIconBasedOnDirection() {
      return this.lang === 'fa' ? 'el-icon-arrow-left' : 'el-icon-arrow-right';
    },
  },
  methods: {
    goNextStep() {
      if (this.nextStep) {
        this.$emit('change-step', this.nextStep);
      }
    },

    goPreviousStep() {
      if (this.previousStep) {
        this.$emit('change-step', this.previousStep);
      }
    },
  },
};
</script>

<style lang="scss">
.step-controllers {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__next {
    margin-left: auto;

    @include rtl() {
      margin-left: 0;
      margin-right: auto;
    }
  }
}
</style>
